import styled from 'styled-components'

export default styled.div`
 {
   display: flex;
   justify-content: space-between;
   padding-top: 20px;
   border-top: 1px solid #e5e5e5;
   .links {
     color: black;
     font-size: 1.8em;
   }
   .copyright {
     font-family: 'Raleway', sans-serif;
     color: grey;
   }
 }
@media (max-width: 768px) {}
@media (max-width: 992px) {}
@media (max-width: 1200px) {}
`



// WEBPACK FOOTER //
// ./src/styles/StyledFooter.js